import { createReducer, on } from '@ngrx/store';

import { SystemUpgradeState } from 'src/app/shared/services/ump';

import {
  loadHealthSuccess,
  loadSystemUpgradeSuccess,
  setIsLoading,
  setPickupCodeOffline,
  setPickupOffline,
  setSessionActive,
} from './global.actions';
import { initialGlobalState } from './global.state';

export const reducer = createReducer(
  initialGlobalState,
  on(setPickupOffline, (state, { pickupOffline }) => ({
    ...state,
    pickupOffline,
  })),
  on(setPickupCodeOffline, (state, { pickupCodeOffline }) => ({
    ...state,
    pickupCodeOffline,
  })),
  on(setIsLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),
  on(loadHealthSuccess, (state, { health }) => ({
    ...state,
    health,
  })),
  on(setSessionActive, (state, { value }) => ({
    ...state,
    isSessionActive: value,
  })),
  on(loadSystemUpgradeSuccess, (state, { systemUpgrade }) => ({
    ...state,
    upgradeStateKnown: true,
    witnessedUpgradeFailure:
      systemUpgrade.state === SystemUpgradeState.FAILED
        ? !state.upgradeStateKnown ||
          state.systemUpgrade.state === SystemUpgradeState.IN_PROGRESS ||
          state.witnessedUpgradeFailure
        : false,
    systemUpgrade: {
      ...systemUpgrade,
    },
  }))
);
